import { useCallback } from 'react';
import { useRemoteConfig, useFeatureFlags } from '@funtech-int/yango-shared';

import { useProfileManager } from '@/shared/hooks/useProfileManager';
import { StreamsWatchingRejectionReason } from '@/scenarios/legacy-player/components/error-boundary-context/error-map/map';
import { useHandleError } from '@/scenarios/legacy-player/components/error-boundary-context/context';

import { featureFlagsScheme } from '../../../lib/featureFlags';
import { TelemetryContentPlace } from '../../Player';
import { getSportLivePlayerConfig } from '../utils/getSportLivePlayerConfig';
import { StreamHandler } from '../../feature-player/hooks/config/use-stream-handler';

interface Props {
    telemetryContentPlace: TelemetryContentPlace;
}

export const useSportPlayerConfigHandler: (props: Props) => StreamHandler = (props) => {
    const remoteConfig = useRemoteConfig();
    const profileManager = useProfileManager();
    const featureFlags = useFeatureFlags(featureFlagsScheme);
    const handleError = useHandleError();

    return useCallback(
        (baseInfo) => {
            if (baseInfo?.__typename === 'SportBroadcast') {
                if (baseInfo.onlineStreams?.streams?.length === 0) {
                    handleError(StreamsWatchingRejectionReason.EMPTY_OTT_STREAMS);
                }
                return getSportLivePlayerConfig(baseInfo, props, {
                    remoteConfig,
                    profileManager,
                    featureFlags,
                });
            }
            return null;
        },
        [featureFlags, handleError, profileManager, props, remoteConfig]
    );
};
